export type MonthNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export const getQueryDate = (year: number, month: MonthNumber = 1, day = 1) => {
  const d = new Date();
  d.setFullYear(year, month - 1);
  d.setDate(day);
  d.setHours(0, 0, 0, 0);

  return d;
};
